<template>
  <div
    v-if="bonusLevels.length"
    data-qa="lpu_loyalty_program"
  >
    <LpuLoyaltyProgramLabel
      v-if="useLabel"
      :min-percent="minPercent"
      :max-percent="maxPercent"
      :welcome-bonus-amount="welcomeBonusAmount"
      @click="isOpenedLpuLoyaltyProgramInfo = true"
    />
    <LpuLoyaltyProgramBadge
      v-else-if="useBadge"
      @click="isOpenedLpuLoyaltyProgramInfo = true"
    />
    <LpuLoyaltyProgramPlate
      v-else
      @click="isOpenedLpuLoyaltyProgramInfo = true"
    />
    <LpuLoyaltyProgramInfo
      v-model="isOpenedLpuLoyaltyProgramInfo"
      :bonus-levels="bonusLevels"
      :welcome-bonus-amount="welcomeBonusAmount"
      :max-payment-percent="maxPaymentPercent"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import type { BonusLevel } from 'src/components/common/LpuLoyaltyProgram/types'
import LpuLoyaltyProgramPlate from 'src/components/common/LpuLoyaltyProgram/components/LpuLoyaltyProgramPlate.vue'
import LpuLoyaltyProgramLabel from 'src/components/common/LpuLoyaltyProgram/components/LpuLoyaltyProgramLabel.vue'
import LpuLoyaltyProgramInfo from 'src/components/common/LpuLoyaltyProgram/components/LpuLoyaltyProgramInfo/LpuLoyaltyProgramInfo.vue'
import LpuLoyaltyProgramBadge from 'src/components/common/LpuLoyaltyProgram/components/LpuLoyaltyProgramBadge.vue'

const props = defineProps<{
  useLabel?: boolean
  useBadge?: boolean
  bonusLevels: BonusLevel[]
  welcomeBonusAmount?: number
  maxPaymentPercent: number
}>()

const minPercent = computed(() => props.bonusLevels[0]?.percent_amount)
const maxPercent = computed(() => (
  props.bonusLevels.length > 1
    ? props.bonusLevels.at(-1)?.percent_amount
    : undefined
))

const isOpenedLpuLoyaltyProgramInfo = ref(false)
</script>
